module.exports = __webpack_public_path__ + "static/media/icon-right.59eeb244.svg";